import { Injectable, ComponentFactoryResolver } from '@angular/core';


@Injectable()
export class DynamicIdtComponentService {

  private components: any[] = [];
  private definitions: any[] = [];
  private compositionsSettingsComponent: unknown;
  private declarativeSettingsComponent: unknown;

  constructor(
    private readonly componentFactoryResolver: ComponentFactoryResolver
  ) {}

  // We set the injection from outside so the Angular AOT won't break on render compilation
  public setSettingsComponents(compositionsSettingsComponent: unknown, declarativeSettingsComponent: unknown) {
    this.compositionsSettingsComponent = compositionsSettingsComponent;
    this.declarativeSettingsComponent = declarativeSettingsComponent;
  }

  public setComponents(components: any[]) {
    this.components = components;
  }

  public setDefinitions(definitions: any[]) {
    this.definitions = definitions;
  }

  public getComponents() {
    return this.components;
  }

  public resolveComponent(componentName: unknown) {
    if (typeof componentName === 'function') {
      return componentName;
    }

    return this.getComponents().find((it) => {
      const factory = this.componentFactoryResolver.resolveComponentFactory(it);
      return factory.selector === componentName;
    });
  }

  public componentByDefinition(definitionId: string | undefined, type: string) {
    const componentDefinition = this.definitions.find((it) => definitionId === it.id);

    // This list stores the component to render in priority order. We later try these components
    // and the first that "exists" is the one we render
    let classNames = [] as unknown[];

    if (definitionId === 'composition' && type === 'settings') {
      classNames.push(this.compositionsSettingsComponent);
    } else {
      switch (type) {
        case 'render': {
          classNames = classNames.concat([
            `${componentDefinition.id}-render`
          ]);
          break;
        }

        case 'workspace': {
          classNames = classNames.concat([
            `${componentDefinition.id}-workspace`,
            `${componentDefinition.id}-render`
          ]);
          break;
        }

        case 'settings': {
          classNames = classNames.concat([
            `${componentDefinition.id}-settings`,
            this.declarativeSettingsComponent
          ]);
          break;
        }

        case 'wireframe': {
          classNames = ['workspace-wireframe'];
          break;
        }

        default: {
          classNames = [];
        }
      }
    }

    return classNames
      .map((componentName) => this.resolveComponent(componentName))
      .filter(isDefined)[0];
  }

}
